import type { SVGProps } from 'react';
export const Plus = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 3c.37 0 .68.3.68.68v5.64h5.64a.68.68 0 0 1 0 1.36h-5.64v5.64a.68.68 0 0 1-1.36 0v-5.64H3.68a.68.68 0 0 1 0-1.36h5.64V3.68c0-.38.3-.68.68-.68"
      clipRule="evenodd"
    />
  </svg>
);
